<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="save()"
        enctype="multipart/form-data"
      >
        <v-card-title class="headline">
          <v-icon>file_upload</v-icon> Subir documento adjunto
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close()">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md6>
                <v-text-field
                  label="Fecha de emisión/ Fecha de validez"
                  type="date"
                  v-model="form.fecha_emision"
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex md6>
                <v-text-field
                  label="Número"
                  v-model="form.nro_certificado"
                  type="number"
                  required
                  maxlength="20"
                  :rules="[
                    (v) => {
                      if (v == null) return 'El campo es obligatorio.';
                      if(v<0)
                        return 'El campo no puede ser negativo.'
                      
                      return true;
                    },
                  ]"
                ></v-text-field>
              </v-flex>
              
              <v-flex md12>
                <v-textarea
                  label="Observación"
                  v-model="form.observacion"
                  maxlength="300"
                ></v-textarea>
              </v-flex>
              <v-flex md12>
                <!-- <v-text-field
                  ref="adjunto"
                  label="Adjuntar documento"
                  type="file"
                  :rules="$validate(['required'])"
                  required
                  @input="handleFileUpload()"
                ></v-text-field> -->
                <input
                  type="file"
                  @change="handleFileUpload()"
                  ref="file"
                  accept="image/*, application/pdf"
                  :rules="$validate(['required'])"
                  required
                />
                <p class="red--text body-1" v-if="errors.file" :rules="$validate(['required'])">*Debe seleccionar un archivo</p>
                <p class="red--text body-1" v-if="errors.size" :rules="$validate(['required'])">*Archivo demasiado grande(Mayor a 3Mb) </p>
                <p class="red--text body-1" v-if="errors.denied" :rules="$validate(['required'])">*Formato no admitido por el sistema</p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos

export default {
  mixins: [validate, crud],
  data() {
    return {
      dialog: false,
      form: {},
      loading: false,
      valid: false,
      file: "",
      tipo_documento:null,
      documento_requisito: {},
      errors: {
        file: false,
        size: false,
        denied: false
      }
    };
  },
  mounted() {
    this.$bus.$on("openDialogSubirDocumento", item => {
      this.documento_requisito = item;
      this.updateList();
      this.dialog = true;
    });
    //this.obtenerTipoDocumento();
  },
  methods: {
    close() {
      this.form = {};
      this.dialog = false;
      this.loading = false;
      this.file = "";
      this.$refs.file.value = "";
      this.errors = {
        file: false,
        size: false,
        denied: false
      }
      this.$bus.$emit("closeDialogDocumentosAdjuntos");
    },

   

    async save() {
      if (this.$refs.file.value === "") {
        this.errors.file = true
        this.valid=false
        return this.errors
      } else {
        this.valid=false
        this.errors.file = false
      }
      if (this.errors.size) {
        this.valid=false
        return this.errors
      }
      if (this.errors.denied) {
        this.valid=false
        return this.errors
      }
      if (this.$refs.form.validate()) {
        let user = this.$storage.get('user')
        try {
          this.loading = true;

          let formData = new FormData();
          formData.append("file", this.file);
          let res = await this.$http.post(
            process.env.API_URL + "public/upload",
            formData
          );
          this.form.url_documento = res.data;
          this.form.id_estado = 1;
          this.form.id_doc_requisito = parseInt(this.documento_requisito.id);
          // this.form.nro_certificado = parseInt(this.form.nro_certificado);
          if (this.$route.params.id) {
            this.form.id_persona = parseInt(this.$route.params.id)
          } else {
            this.form.id_persona = user.id_persona
          }
          res = await this.$service.graphql({
            query: `
              mutation add($persona_doc_requisito: NewPersonaDocRequisito!){
                personaDocRequisitoAdd(persona_doc_requisito: $persona_doc_requisito){
                  id
                }
              }
            `,
            variables: {
              persona_doc_requisito: this.form
            }
          });
          if (res.personaDocRequisitoAdd.id) {
            this.$message.success();
            this.close();
          } else {
            this.$message.error();
            this.loading = false;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    //  async obtenerTipoDocumento() {
    //   let respuesta = await this.$service.graphql({
    //     query: `
    //       query{
    //         params(tipo:"tipo_documento"){
    //           rows{
    //             id
    //             valor
    //           }
    //         }
    //       }
    //     `,
    //   });
    //   this.tipo_documento = respuesta.params.rows;
    //   console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'+this.tipo_documento);
    // },
    handleFileUpload() {
      if (this.$refs.file.value !== '') {
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].size > 3145728) {
          this.errors.size = true
        } else {
          this.errors.size = false
        }
        if (this.$refs.file.value === '') {
          this.errors.file = true
        } else {
          this.errors.file = false
        }
        if (this.$refs.file.files[0].type.includes('application/pdf') || this.$refs.file.files[0].type.includes('image/')) {
          this.errors.denied = false
        } else {
          this.errors.denied = true
        }
        this.file = file;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/SubirDocumentoAdjunto.vue